import { RootRedirect } from '@common/routes/RootRedirect';
import { RouteObject } from 'react-router-dom';
import { AuthLayout } from '@pages/Auth/AuthLayout';
import OTPPage from '@pages/Auth/OTP';
import ResetPasswordPage from '@pages/Auth/ResetPassword';
import SetNewPassword from '@pages/Auth/SetNewPassword';
import SSOPage from '@pages/Auth/SSO';
import LoginPage from '@pages/Auth/Login';
import InviteUserPage from '@pages/Auth/InviteUser';
import { Init as SSOInit } from '@pages/Auth/SSO/Init';
import { Connect as SSOConnect } from '@pages/Auth/SSO/Connect';
import { Apaleo as SSOApaleo } from '@pages/Auth/SSO/Apaleo';
import { Properties as SSOProperties } from '@pages/Auth/SSO/Properties';
import { RegisterConfirmation as SSORegisterConfirmation } from '@pages/Auth/SSO/RegisterConfirmation';
import AcademySignup from '@pages/Auth/AcademySignup';
import ClerkOTPStartPage from '@pages/Auth/Clerk/pages/clerk-otp-start-page';
import ConditionalLoginPage from '@pages/Auth/Clerk/pages/clerk-login-page';

export const authRoutes: RouteObject[] = [
  {
    path: '/',
    element: <RootRedirect />
  },
  { path: '/academy-signup', element: <AcademySignup /> },
  {
    path: '/',
    element: <AuthLayout />,
    children: [
      { path: '/login', element: <ConditionalLoginPage /> },
      { path: '/login-legacy', element: <LoginPage /> },
      { path: '/login-clerk', element: <ConditionalLoginPage /> },
      { path: '/login-create-otp', element: <ClerkOTPStartPage /> },
      { path: '/otp', element: <OTPPage /> },
      { path: '/get-new-password', element: <ResetPasswordPage /> },
      { path: '/reset-password/:token', element: <SetNewPassword /> },
      { path: '/sso', element: <SSOPage /> },
      { path: '/account/verify-invited-user', element: <InviteUserPage /> },
      { path: '/sso/init/:pms/:code', element: <SSOInit /> },
      { path: '/sso/connect/:id/:pms/:code', element: <SSOConnect /> },
      { path: '/sso/properties', element: <SSOProperties /> },
      { path: '/sso/register', element: <SSORegisterConfirmation /> }
    ]
  },
  { path: '/sso/apaleo', element: <SSOApaleo /> }
];
